module.exports = __webpack_public_path__ + "img/csg-transformed.b6cb7d7d.png";